import { WorkflowStatusForm } from "../../../components/workflow-status/WorkflowStatusForm";

const AddWorkflowStatus = () => {
  return <WorkflowStatusForm />;
};

export default AddWorkflowStatus;